import { render } from "./nestedjsontotable.vue?vue&type=template&id=5b7cf976&scoped=true"
import script from "./nestedjsontotable.vue?vue&type=script&lang=js"
export * from "./nestedjsontotable.vue?vue&type=script&lang=js"

import "./nestedjsontotable.vue?vue&type=style&index=0&id=5b7cf976&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7cf976"]])

export default __exports__